/*
 *   File : radio.js
 *   Author : https://evoqins.com
 *   Description : Custom radio button component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment } from 'react';

//Custom components
import { Icon } from '../Icon';

const CustomRadio = (props) => {
    return (
        <div >
            {props.label &&
                <label className={`e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-8px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }
            <div className={props.className}>
                {props.data.map((data, key) => (
                    <div key={key} className={`${props.selected === data.id ? 'pe-none' : ''} d-flex align-items-center gap-2 cursor-pointer w-max-content`}
                        onClick={() => props.handleSelect(data.id)}
                        style={{ opacity: props.disabled && props.selected !== data.id ? 0.5 : 1, pointerEvents: props.disabled && props.selected !== data.id ? 'none' : 'auto' }}>
                        <Icon icon={props.selected === data.id ? "radio-active" : "radio-inactive"}
                            size="1rem"
                            className="d-flex" />
                        <p className='mb-0 e-text-dark-gray e-font-14 e-primary-font e-font-weight-400 line-height-18px'>
                            {data.label}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CustomRadio;
